import React from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';
import translate from 'components/hoc/translate';
import { SuspiciousIcon } from 'assets/materialIcons/materialIcons';
import { colors } from 'material-ui/styles';

const OrderSuspiciousField = (props) => {
    const { record, translate } = props;

    if (!record.suspicious) {
        return null;
    }

    return (
        <IconButton
            tooltip={ translate('notifications.orders.suspicious') }
            touch={ false }
            tooltipPosition='top-center'
            style={ { padding: 0, width: '30px', height: '30px' } }
        >
            <SuspiciousIcon color={ colors.red800 }/>
        </IconButton>
    );
};

OrderSuspiciousField.propTypes = {
    record: PropTypes.object,
    translate: PropTypes.func.isRequired,
};

OrderSuspiciousField.defaultProps = {
    record: {},
    touch: false,
};

export default translate(OrderSuspiciousField);



// WEBPACK FOOTER //
// ./src/components/field/OrderSuspiciousField.js